import { TrendUp, TrendDown, Minus } from "@phosphor-icons/react";

export default function TrendBadge({ trend, confidence }) {
  if (!trend) {
    return (
      <span className="inline-flex items-center gap-1 border border-zinc-800 text-zinc-600 px-2 py-0.5 text-[10px] uppercase tracking-wider">
        <Minus size={10} weight="bold" /> N/A
      </span>
    );
  }
  const map = {
    bullish: {
      cls: "bg-[#00FF66]/10 text-[#00FF66] border-[#00FF66]/40",
      Icon: TrendUp,
    },
    bearish: {
      cls: "bg-[#FF3B30]/10 text-[#FF3B30] border-[#FF3B30]/40",
      Icon: TrendDown,
    },
    neutral: {
      cls: "bg-zinc-800/40 text-zinc-400 border-zinc-700",
      Icon: Minus,
    },
  };
  const { cls, Icon } = map[trend] || map.neutral;
  return (
    <span
      data-testid={`trend-badge-${trend}`}
      className={`inline-flex items-center gap-1 border ${cls} px-2 py-0.5 text-[10px] uppercase tracking-wider tabular`}
    >
      <Icon size={10} weight="bold" />
      {trend}
      {typeof confidence === "number" && (
        <span className="opacity-70">· {confidence}%</span>
      )}
    </span>
  );
}
